{
	"id": 7819575,
	"numericId": 7819575,
	"collectionId": 785,
	"status": "ACTIVE",
	"sessionTime": 0,
	"startTime": "2026-05-20T06:08:40.381Z",
	"examBreak": null,
	"timeAllocation": null,
	"progressList": [],
	"sessionItems": [
		{
			"id": 103650,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Gain further insight by reviewing the following three videos showing the perspectives of Alex’s mom, Mr. Smith (a colleague), and Coach Buckner.",
				"items": [
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-3/m3s1_perspective_alex_mom.mp4",
							"transcript": "**Alex’s Mom: Video Conference with Mr. Arnold**\n\nThe video shows Alex’s mom in her home having a video conference with Mr. Arnold. Alex’s mom is speaking, and Mr. Arnold acknowledges her by nodding and smiling throughout the whole video conference.\n\nAlex’s Mom: Mr. Arnold, I wanted to thank you for the extra time you’ve given Alex. He’s been talking about your class nonstop, and I can tell he feels heard and understood.\n\nI also appreciate you’ve kept me in the loop. If Alex needs more than classroom support, I hope we can involve his counselor. It means a lot to know you’re following the school’s guidelines and maintaining clear professional boundaries.\n\nYour encouragement has made a real difference in his confidence. I am truly grateful, Mr. Arnold.",
							"transcriptTitle": "Transcript for Alex’s Mom video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Alex’s Mom"
					},
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-3/m3s1_perspective_mr_smith.mp4",
							"transcript": "**Mr. Smith’s Reflection**\n\nThe video shows Mr. Smith in his high school classroom reflecting. Mr. Arnold’s classroom is visible across the hall.\n\nMr. Smith: Day in and day out, we face things with our students that few professions ever encounter.\n\n[Mr. Smith looks out his open classroom door toward Mr. Arnold’s classroom.] I see how engaged his class is. His dedication inspires me.\n\nBut when we do a little more outside the classroom, we need a pre-established routine and procedure that’s open to all students, things like posted times, a visible location, and an invitation that any student can act on. Good intentions work best when backed by clear processes.\n\nAs a department, we collaborate to keep after-school support transparent and objective. If a student needs more than academic coaching, we involve the counselor or administrator so roles don’t blur and we maintain professional boundaries.\n\nThat’s how we honor our ethical code, fidelity to the MCEE, and professional practices that the whole community can trust.",
							"transcriptTitle": "Transcript for Mr. Smith (Colleague) video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Mr. Smith (Colleague)"
					},
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-3/m3s1_perspective_coach_buckner.mp4",
							"transcript": "**Coach Buckner’s Reflection**\n\nThe video shows Coach Buckner reflecting as she prepares for practice in the high school gymnasium with the girls’ basketball team.\n\nCoach Buckner: That’s an interesting idea: coaching debate in Old English. It’s creative and keeps the focus where it should be: on learning in appropriate structured settings.\n\nWhen help continues after school, we stick to posted times and open sessions so every student has a chance to join, including our teammates who struggle with Shakespeare, and we coordinate with our teachers if a student needs more than practice or tutoring, we include the counselor or administrator. That way we respect boundaries and still help our kids.\n\n[Coach Buckner picks up a basketball.]\n\nNow how would the Bard call it? Lay on the glass with valor and seize each rebounding orb.\n\n[The basketball team laughs, and Coach Buckner looks toward them briefly.]\n\nAll right, creativity plus professionalism. Circle up. Let’s get better together.\n\n[Coach Buckner and the girls’ basketball team clap.]",
							"transcriptTitle": "Transcript for Coach Buckner video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Coach Buckner"
					}
				],
				"title": "Scenario 1: Perspectives",
				"instruction": "**Directions:** Select each of the following three tabs to review the three perspective videos. Select the play button in each tab to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_perspective_resource_set",
				"language": "en-US",
				"position": 3,
				"sourceId": 3030
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103651,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The first step in navigating ethical dilemmas is to understand how your values and dispositions can affect your decisions. Educators’ decisions are influenced by two frameworks: dispositional and regulatory. The influence of each framework varies, and educators can be influenced more strongly by one framework than by another. Reflect on what influenced Mr. Arnold’s decisions regarding his relationships with students.",
				"title": "Scenario 1: Reflect",
				"question": "Was Mr. Arnold influenced more by his dispositional framework or the regulatory framework?",
				"instruction": "**Directions:** Select each of the following two frameworks to read its definition. Then answer the question by choosing one of the frameworks and selecting Submit. If needed, you can try again and select the alternative framework to reveal the explanation."
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "scenario_reflect_framework_choice",
				"language": "en-US",
				"position": 4,
				"sourceId": 3040
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "ed9334bc-b401-492f-99a8-df55dab7b6da",
						"isCorrect": true
					},
					{
						"choiceId": "b958d359-d08e-4f6c-8b25-959e911ffb9b",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "ed9334bc-b401-492f-99a8-df55dab7b6da",
					"detailed": {
						"text": "Mr. Arnold’s interactions with his students are guided primarily by his personal commitment to helping them, rather than by formal policy. In doing so, he is operating within the dispositional framework.\n\nWould it be helpful if he checked for any policies or guidelines regarding meeting with students virtually or face-to-face? Of course! The regulatory and dispositional frameworks should inform your decisions."
					},
					"language": "en-US"
				},
				{
					"type": "STATIC",
					"choiceId": "b958d359-d08e-4f6c-8b25-959e911ffb9b",
					"detailed": {
						"text": "Mr. Arnold is not primarily guided by the regulatory framework. There is no indication that he pauses to consult policies related to after‑school meetings, virtual or electronic communication with students, or expectations for transparency and documentation."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "ed9334bc-b401-492f-99a8-df55dab7b6da",
						"icon": "heart-handshake",
						"text": "Influenced More by Dispositional Framework",
						"description": "The personal and professional attitudes, values, and beliefs that inform a professional educator’s decision making.",
						"numFirstSelections": 0
					},
					{
						"id": "b958d359-d08e-4f6c-8b25-959e911ffb9b",
						"icon": "scale",
						"text": "Influenced More by Regulatory Framework",
						"description": "School or district policies, state statutes, and criminal laws that form the basis for conduct absolutes and inform a professional educator’s decision making.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103652,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"overview": {
					"title": "The Professional Educator and the Student",
					"summary": "This module contains three activities and a five-question end-of-module knowledge check. It will take approximately 40 to 50 minutes to complete the entire module.",
					"moduleNumber": 3,
					"activityCount": 3,
					"knowledgeCheckCount": 5,
					"estimatedDurationMinutes": 45
				},
				"moduleOutline": {
					"heading": "Module Outline",
					"sections": [
						{
							"items": [
								{
									"icon": "circle-play",
									"title": "Video"
								},
								{
									"icon": "messages-square",
									"title": "Perspectives"
								},
								{
									"icon": "square-pen",
									"title": "Reflect"
								},
								{
									"icon": "compass",
									"title": "Explore"
								},
								{
									"icon": "clipboard-check",
									"title": "Review"
								},
								{
									"icon": "chart-column-increasing",
									"title": "Analysis"
								}
							],
							"title": "Scenario 1: Mr. Arnold"
						},
						{
							"title": "Ethical Situations: Potential Ethical Outcomes"
						},
						{
							"items": [
								{
									"icon": "circle-play",
									"title": "Video"
								},
								{
									"icon": "messages-square",
									"title": "Perspectives"
								},
								{
									"icon": "square-pen",
									"title": "Reflect"
								},
								{
									"icon": "compass",
									"title": "Explore"
								},
								{
									"icon": "clipboard-check",
									"title": "Review"
								},
								{
									"icon": "chart-column-increasing",
									"title": "Analysis"
								}
							],
							"title": "Scenario 2: Coach Buckner"
						},
						{
							"title": "Module 3 Summary"
						}
					]
				},
				"learningObjectives": {
					"heading": "Learning Objectives",
					"objectives": [
						"Analyzing a scenario to differentiate how dispositional and regulatory frameworks influence decision making and determining an appropriate course of action",
						"Evaluating competing tensions to select actions aligned with ethical principles",
						"Applying decision criteria aligned to the *Model Code of Ethics for Educators* (*MCEE*) to resolve ethical scenarios"
					]
				}
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_intro",
				"language": "en-US",
				"position": 1,
				"sourceId": 3010
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103653,
			"versionId": 1,
			"blockId": null,
			"type": "SATA",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The second step in navigating ethical dilemmas is exploring the risks to the ethical principles.",
				"title": "Scenario 1: Explore",
				"question": "Which of the following ethical principles were at immediate risk for Mr. Arnold? Select all that apply.",
				"instruction": "**Directions:** Select each of the following nine expandable text buttons to review information about each principle of ethical decision making.",
				"ethicalPrinciples": {
					"items": [
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "**P**romoting Solution Discovery",
							"description": "Creating opportunities for self-advocacy and problem resolution is a foundational principle in ethical decision making. Educators should refer students or colleagues to suitable school resources and officials and ensure that these students and colleagues follow up, rather than handle issues themselves. Not only is this in the best interest of those involved, but it also allows situations to be handled objectively and avoids blurring the scope of the educator’s position with that of more expansive roles such as those of counselor, confidant, caregiver, and rescuer. The primary role of the professional educator is most often associated with the tasks of teaching and learning.\n\n**Guiding Questions**\n- What are the inherent professional risks in attempting to fix the immediate or long-term challenges, problems, and obstacles that students, colleagues, or other learning community stakeholders encounter?\n- Am I accepting responsibilities, performing duties, or providing services that correspond with my training and area of certification?\n- How can I help colleagues when their role as a professional educator overlaps with other societal expectations?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "**R**isk Mitigation",
							"description": "Since educators provide services directly to minors who remain under their care and supervision for extended periods of time without the presence of parents or guardians, the field of education has many professional risks and vulnerabilities. It is important that all educators continually reflect on how to best mitigate risks that may compromise their professional and personal credibility, career goals, personal well-being, and effectiveness as a teacher.\n\n**Guiding Questions**\n- How can a seemingly innocuous and insignificant decision have the potential to put my educational practice at risk?\n- What professional-risk situations inherent in my educational practice do I need to carefully consider (for example, chaperoning an overnight field trip, being approached by a student for personal advice)?\n- What conversations can I have with my colleagues to help identify ways to mitigate risks in situations that we commonly encounter?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "**O**bjectivity and Neutrality Are Maintained",
							"description": "By maintaining objectivity and neutrality, professional educators should be able to evaluate a situation without emotional entanglements or bias. Remaining objective and neutral mitigates the risks of over-identifying with one party, becoming too focused on the needs of an individual, or advocating for a singular interest instead of advocating for solutions.\n\n**Guiding Questions**\n- When encountering competing tensions (for example, school policy versus what I think is best for a student or colleague; parental influence versus administrative influence), how can I determine the best course of action?\n- How can I remain objective and neutral when I have multiple relationships in the schooling community and as a community member (for example, I’m a friend of one of my student’s parents; I am a youth group leader at a student’s religious center; I coach a student on a club volleyball team during the summer)?\n- How can I best caution a colleague if I suspect the colleague is becoming overwhelmed by the needs of a student?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "**E**nsuring Student Welfare",
							"description": "Since the individuals receiving services are minors and the educators have been ascribed in loco parentis responsibilities, the primary responsibility of educators is to ensure the students’ safety and welfare. The scope of this charge is not just limited to physical safety, but it also includes emotional, intellectual, psychological, and sexual safety.\n\n**Guiding Questions**\n- Am I doing everything in my power to establish a safe and secure environment for academic, personal, and social growth to occur?\n- Am I willing to safeguard students from duress even if I am not directly responsible for the students?\n- How can I best confront a colleague regarding acts, either committed or omitted, that have the potential to compromise a student’s welfare?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "**T**ransparency in Actions and Communications",
							"description": "Educators must be transparent in their actions and communications. Transparency establishes openness, accountability, trust, credibility, and boundaries. Failure to be sufficiently transparent with appropriate stakeholders (for example, parents, guardians, students, colleagues, administrators) may result in misinterpretation of motives or the appearance of impropriety. Transparency is the best way for educators to ensure that their decisions and behaviors can withstand public scrutiny.\n\n**Guiding Questions**\n- How can I ensure that all communications with students, including digital and electronic communications, are conducted with transparency?\n- How can I balance the need for transparency in my actions and communications with protecting highly confidential information that I am expected to retain (which is considered a “qualified privilege” by the courts)?\n- How do I best approach a colleague about rumors of impropriety that are a result of their lack of transparency in decision making?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "**H**onoring the Boundaries of Role, Time, and Place",
							"description": "Boundaries encompass the verbal, physical, emotional, and social distances that an educator must maintain to ensure security, structure, and predictability in an educational environment. Most often, the boundaries that are transgressed relate to role, time, and place. By respecting the functions and limits of contracted roles, as well as the working hours and location of the learning environment, secure boundaries are in place for all members of the school community.\n\n**Guiding Questions**\n- In reflecting on my educational practice, which dispositions most risk eroding professional boundaries (for example, assisting with students’ personal challenges, extending academic support beyond school hours, engaging in extracurricular activities, communication with students, parents, and colleagues)?\n- Am I thinking about all my interactions with students (for example, in the school, in the community, and at social functions) as an extension of my professional responsibilities as an educator?\n- How can my colleagues and I openly discuss and agree on boundaries that are most appropriate for our educational context?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "**I**ntegrity of the Profession Is Promoted by the Educator",
							"description": "Educators’ actions reflect on the schooling community, the district, and the profession. An individual educator’s positive actions have the potential to inspire public confidence in the profession. On the other hand, negative actions can cast shadows of doubt and distrust by undermining the effectiveness of a healthy educational structure. The professional educator has an obligation to hold himself or herself responsible for ethical conduct. The educator should take steps when he or she has reason to believe that another educator may be approaching or engaged in an ethically compromising situation.\n\n**Guiding Questions**\n- How often am I reflecting on the daily decisions that I make as a professional educator and how those decisions may affect the integrity of the profession?\n- What steps can I take when I believe that a colleague may be approaching or involved in an ethically compromising situation?\n- How can I best advocate for the profession while also working to reconcile points of disagreement within the school or district?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "**C**ode of Ethics for Educators Is Maintained with Fidelity",
							"description": "Having an ethics code is a proclamation that a profession is better off when ethical standards are not based solely on individual assessments of what is or is not ethically acceptable but reflect consensus among members on a common purpose. For the education discipline, the *Model Code of Ethics for Educators* (*MCEE*) is a guide for what educators should expect of themselves and one another and should be maintained with fidelity. The *MCEE* assists educators in their efforts to resolve ethical dilemmas and helps educators defend their decisions to schooling-community constituents, institutions, courts, and any other agency that would encourage them to go against the values of the profession. The formal standards are not a substitute for an active, deliberate, and creative approach to fulfilling your ethical responsibilities. They prompt, guide, and inform an educator’s ethical decision-making; they do not serve as a substitute for it.\n\n**Guiding Questions**\n- How can educators from my school or district work together to identify common ethical dilemmas that we encounter?\n- Is there a way to use the *MCEE* as a prompt to discuss resolutions to those ethical dilemmas?\n- Since ethical dilemmas are often situational, contextual, and likely to change over time, how can the *MCEE* continue to guide and inform my decision making as I engage in the practical realities of my work?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "**S**tewardship of the Law and Public Trust",
							"description": "Employment policies, licensure statutes, and community laws represent conduct absolutes that have originated from a history of judicial activity. They represent the lowest standard of acceptable behavior deemed necessary to safeguard community members. However, the professional educator is aware that trust in the profession depends on a level of conduct and responsibility that may be higher than what is required by law.\n\n**Guiding Questions**\n- How will relevant procedures, policies, and laws inform my decision making when I encounter ethical dilemmas?\n- It has been said that misconduct is not an event but a process. Will I be able to identify those situations where a series of gradual and unintentional missteps could lead to the transgression of a conduct absolute?\n- What steps can I take when I believe that a colleague may be approaching or involved in actions that may lead to the transgression of a policy, statute, or law?"
						}
					],
					"title": "Ethical Principles"
				}
			},
			"metadata": {
				"type": "SATA",
				"ui_type": "scenario_principle_sata_activity",
				"language": "en-US",
				"position": 5,
				"sourceId": 3050
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "ea9f0a97-8219-4146-9583-0182cb9d9c2f",
						"isCorrect": true
					},
					{
						"choiceId": "36f2a118-1f41-4244-ae43-a48d24098736",
						"isCorrect": true
					},
					{
						"choiceId": "389b2787-186e-40a4-9edb-5ce0b284f1d4",
						"isCorrect": true
					},
					{
						"choiceId": "71697505-621e-4cb0-8351-a5d4000b52af",
						"isCorrect": true
					},
					{
						"choiceId": "e1855862-91fc-478e-a8df-4ae06feca3d7",
						"isCorrect": true
					},
					{
						"choiceId": "34d8bd43-ddb9-4b37-adbe-ceb49c3ab95d",
						"isCorrect": true
					},
					{
						"choiceId": "b04c293b-4db8-4049-98fb-3cdbfbcb4ed1",
						"isCorrect": false
					},
					{
						"choiceId": "721e1033-d6dd-4a7c-bb55-b677204b83df",
						"isCorrect": false
					},
					{
						"choiceId": "88b3ab7d-ee2b-4590-80ad-9e2e433da9b7",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 9,
					"min": 1
				}
			},
			"feedback": null,
			"response": {
				"type": "MULTIPLE_SELECT",
				"choices": [
					{
						"id": "ea9f0a97-8219-4146-9583-0182cb9d9c2f",
						"text": "Promoting Solution Discovery",
						"numFirstSelections": 0
					},
					{
						"id": "36f2a118-1f41-4244-ae43-a48d24098736",
						"text": "Risk Mitigation",
						"numFirstSelections": 0
					},
					{
						"id": "389b2787-186e-40a4-9edb-5ce0b284f1d4",
						"text": "Objectivity and Neutrality Are Maintained",
						"numFirstSelections": 0
					},
					{
						"id": "71697505-621e-4cb0-8351-a5d4000b52af",
						"text": "Ensuring Student Welfare",
						"numFirstSelections": 0
					},
					{
						"id": "e1855862-91fc-478e-a8df-4ae06feca3d7",
						"text": "Transparency in Actions and Communications",
						"numFirstSelections": 0
					},
					{
						"id": "34d8bd43-ddb9-4b37-adbe-ceb49c3ab95d",
						"text": "Honoring the Boundaries of Role, Time, and Place",
						"numFirstSelections": 0
					},
					{
						"id": "b04c293b-4db8-4049-98fb-3cdbfbcb4ed1",
						"text": "Integrity of the Profession Is Promoted by the Educator",
						"numFirstSelections": 0
					},
					{
						"id": "721e1033-d6dd-4a7c-bb55-b677204b83df",
						"text": "Code of Ethics for Educators Is Maintained with Fidelity",
						"numFirstSelections": 0
					},
					{
						"id": "88b3ab7d-ee2b-4590-80ad-9e2e433da9b7",
						"text": "Stewardship of the Law and Public Trust",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103654,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Potential Ethical Outcomes",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "The teacher changes the grade quietly. The student graduates, but the decision undermines grading integrity and fairness to other students."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "The teacher declines to change the grade and reports the request to administration. Together they explore alternative solutions such as credit recovery or summer coursework."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "Another student overhears the discussion about grade adjustment and reports the conversation to administration, triggering an investigation and social media backlash."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "A school counselor approaches an English teacher about a senior who is failing and may not graduate. The counselor emphasizes the student’s hardships and future aspirations and suggests a grade adjustment.",
					"title": "Situation 3: Grade Integrity",
					"number": 3,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 10,
				"sourceId": 3100
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103655,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Review the ethical principles to determine whether each ethical principle was at immediate risk for Mr. Arnold.",
				"items": [
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Alex begins to share personal information, and Rebecca expresses deeper emotional investment. Mr. Arnold’s actions increase the chance that he may unintentionally act in a counseling role."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "Promoting Solution Discovery"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "The scenario contains multiple small, seemingly harmless decisions that can easily escalate into ethical vulnerabilities, such as offering unstructured one-on-one after-school help, encouraging unmonitored messaging, engaging in emotionally charged student disclosures, and not establishing clear procedures."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "Risk Mitigation"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Arnold focuses primarily on two students, Rebecca and Alex, and gives them extra time and attention. Even if motivated by good intentions, this behavior can cause students to perceive favoritism, create a lack of neutrality on Mr. Arnold’s part, and cause emotional entanglement, especially when Alex raises personal issues."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "Objectivity and Neutrality Are Maintained"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "While no direct physical or emotional harm occurs in the scene, the setup creates conditions in which student safety, both emotional and relational, could be compromised."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "Ensuring Student Welfare"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Arnold’s after-school invitation is not posted, not communicated to all students, and not documented. Additionally, he invites a student to message him individually."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "Transparency in Actions and Communications"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Mr. Arnold invites individual students, Rebecca and Alex, to meet after school and communicate outside the classroom. These invitations are informal, unstructured, and only directed toward single students."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "Honoring the Boundaries of Role, Time, and Place"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "Integrity of the Profession Is Promoted by the Educator"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "Code of Ethics for Educators Is Maintained with Fidelity"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "Not At Immediate Risk",
							"explanation": ""
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "Stewardship of the Law and Public Trust"
						}
					}
				],
				"title": "Scenario 1: Review",
				"instruction": "**Directions:** Select each of the following nine flip cards to explore whether each ethical principle was at immediate risk for Mr. Arnold. Each of the nine cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_principle_review_cards",
				"language": "en-US",
				"position": 6,
				"sourceId": 3060
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103656,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will consider a scenario involving many of the ethical decisions that educators encounter as they interact with students in everyday situations.\n\nFirst, you will review a video that shows an educator’s interactions with his students. Then, you will gain further insight by reviewing three videos showing the perspectives of people involved in the scenario. After observing the videos, you will reflect on and explore the ethical dilemmas depicted in the scenario.",
				"media": [
					{
						"type": "VIDEO",
						"title": "Mr. Arnold",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-3/m3s1_scenario.mp4",
						"transcript": "**Mr. Arnold’s High School Class: Discussion of Shakespeare and Macbeth**\n\nThe video shows a high school classroom with three students, Rebecca, Alex, and Chris, talking to Mr. Arnold.\n\nRebecca: Mr. Arnold? “Canst thou not minister to a mind diseased?”\n\nMr. Arnold: What is it, Rebecca?\n\nRebecca: Well, you know where Lady Macbeth wants Macbeth to kill the king? Is Shakespeare trying to say that the only way to achieve power is by being ruthless?\n\nMr. Arnold: I think Shakespeare’s point is that it depends on how badly you want power and what you’re prepared to do to get it.\n\nAlex: Men always want that power, huh?\n\nMr. Arnold: Not necessarily, Alex. Rebecca, did I answer your question?\n\nRebecca: Well, kind of, yeah. I think there’s more to it, though. I love this play, Mr. Arnold, but we’re not discussing it enough.\n\nMr. Arnold: Hm, well, okay. I’m glad you’re enjoying the play. I’ll be here in the classroom after school. You can come by. I’m always interested in hearing another interpretation.\n\nRebecca: Okay, see you then.\n\n[Rebecca leaves.]\n\nAlex: Shakespeare is supposed to be one of the most romantic writers, right?\n\nMr. Arnold: Romantic, yes. But there is conflict and drama as well.\n\nAlex: Yeah, like a lot of people, I guess, like my parents.\n\nMr. Arnold: Yes, well, people from then and now can relate to Shakespeare’s storytelling.\n\nChris: [interrupting] Look, can someone else ask a question?\n\nMr. Arnold: [to Alex] Do you mind?\n\nChris: Dude, I don’t understand any of this. Like, I do not understand anything this guy is writing. It’s not even real English.\n\nMr. Arnold: The ol’ Elizabethan language. It’s a little different.\n\nChris: I’m glad it’s funny for you. I don’t get it.\n\nMr. Arnold: Okay, are you going to be at debate team practice tonight?\n\nChris: Of course.\n\nMr. Arnold: Perchance I lead thy team and brethren thus? And speakest I with verbs that Bard did use?\n\n[Alex and Chris both look surprised.]\n\nChris: Huh?\n\nMr. Arnold: What if I lead the team using Shakespearean English tonight?\n\nChris: Seriously? That’d be weird, but cool. Okay, awesome.\n\nMr. Arnold: Alex, we both need to get to our next session.\n\nAlex: Okay, Mr. Arnold.\n\nMr. Arnold: I’ll be here if you need anything. If you send me a message, I’ll get it.\n\nChris: See you at debate practice, Mr. Arnold.\n\nMr. Arnold: Looking forward to it.\n\n[Mr. Arnold, Alex, and Chris leave the classroom.]",
						"transcriptTitle": "Transcript for Mr. Arnold video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					}
				],
				"title": "Scenario 1: Mr. Arnold",
				"instruction": "**Directions:** Review the following video to learn about the scenario. Select the play button to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 2,
				"sourceId": 3020
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103657,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "",
				"items": [
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-3/m3_rebecca.png"
							}
						],
						"title": "Rebecca",
						"analysis": {
							"text": "In this scenario, Rebecca is actively reading Macbeth and wants to discuss the play further. These moments of academic enthusiasm are what teachers aim to encourage. While it is appropriate for Mr. Arnold to invite Rebecca to stop by the classroom after school, he must keep ethical guidelines in mind. In this specific situation, ensuring transparency and objectivity in all student interactions is key.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are examples of questions that Mr. Arnold should ask himself.\n- How can I offer all students equal opportunities for after-class discussions\n- Have I set a specific time and location for after-school help that everyone knows about?\n- How can I establish that my educational intent is transparent and avoids misinterpretation?\n- Can I collaborate with colleagues to address common challenges?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Maintain transparency and objectivity in all student interactions.**",
							"title": "Key Takeaway"
						}
					},
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-3/m3_alex.png"
							}
						],
						"title": "Alex",
						"analysis": {
							"text": "Teachers often offer support to students who seek comfort and advice. In this scenario, Macbeth has triggered Alex’s personal emotions. Mr. Arnold offers to listen if Alex needs someone to talk to. While this offer was well intentioned, educators must be careful not to take on a role, such as school counselor, for which they are not trained, as this can blur professional boundaries. Even though Mr. Arnold was not acting inappropriately, boundary violations often occur when educators assume a role for which they are not prepared.\nAdditionally, Mr. Arnold used digital messaging to communicate with Alex. Digital communication can blur boundaries that are clearer in face-to-face interactions, increasing the risk of misunderstandings. Additionally, using platforms that are often used for personal interactions, like social media, may create a context that can blur these boundaries. Mr. Arnold has assumed more risk simply because of the method of communication.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are examples of questions that Mr. Arnold should ask himself.\n- What is the local policy regarding the use of online services to communicate with students?\n- Am I able to maintain transparency using this form of communication?\n- Is this communication recorded and documented?\n- Can I share the student’s communications with a counselor, principal, or parent, if needed?\n- Is this form of communication the most appropriate way to address the student’s needs?\n- How can I support students while maintaining professional boundaries?",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Use technology thoughtfully and maintain clear professional boundaries when supporting students.**",
							"title": "Key Takeaway"
						}
					},
					{
						"media": [
							{
								"type": "IMAGE",
								"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-3/m3_chris.png"
							}
						],
						"title": "Chris",
						"analysis": {
							"text": "Of all Mr. Arnold’s decisions, coaching the debate team in Elizabethan English stands out as the most ethically sound.\nThis approach is both engaging and educational, helping Chris and his teammates become comfortable with Shakespeare’s language in a familiar and appropriate setting. If Chris is still struggling with Shakespeare, Mr. Arnold could invite him to a regularly scheduled after-school session open to all students.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are examples of questions that Mr. Arnold should ask himself.\n- How can something as simple as assisting students turn into a professional challenge?\n- What could possibly go wrong?\n- How do I ensure my interactions outside the classroom remain professional and ethical?\n\nTeacher-student interactions outside the classroom can be complex. The *MCEE* provides guidance for navigating these situations.",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Follow established ethical guidelines and maintain professionalism in all student interactions**, especially outside the classroom and/or normal school hours.",
							"title": "Key Takeaway"
						}
					}
				],
				"title": "Scenario 1: Analysis",
				"instruction": "**Directions:** Select each of the following three tabs with student names to understand each student's interaction with Mr. Arnold. Select each of the three tabs to gain further insight about each student. Select each of the expandable text buttons within each tab to review the information about each person."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_analysis_cards",
				"language": "en-US",
				"position": 7,
				"sourceId": 3070
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103658,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Potential Ethical Outcomes",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Mr. Bennett moves Malik’s desk into the hallway and tells him to finish the assignment there. The class becomes quieter, but Malik is left unsupervised and feels embarrassed when other students pass by. A parent later contacts the principal with concerns about student dignity and supervision."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Mr. Bennett pauses before responding, redirects Malik privately, and documents the repeated behavior. He follows the school’s behavior-support process and contacts the appropriate staff member or administrator for guidance. Malik remains supervised, and Mr. Bennett’s response protects both the student’s welfare and the learning environment."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "Mr. Bennett removes Malik from the classroom without documenting the reason or notifying anyone. Later, Malik misses important instruction and tells his family that he was excluded from class unfairly. The situation raises concerns about inconsistent discipline, lack of transparency, and whether Mr. Bennett followed school procedures."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Mr. Bennett is a seventh-grade social studies teacher. During independent work, one student, Malik, repeatedly interrupts classmates, makes jokes, and refuses to begin the assignment. Mr. Bennett is frustrated because this has happened several times that week. He considers making Malik sit in the hallway with his desk so the rest of the class can work quietly.",
					"title": "Situation 8: Disruptive Behavior",
					"number": 8,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 15,
				"sourceId": 3150
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103659,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Potential Ethical Outcomes",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "The student posts a video on social media from Mr. Jordan’s home, revealing personal details. The video spreads widely, raising privacy concerns and damaging Mr. Jordan’s reputation."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "The student’s parents accompany the student and supervise the visit, ensuring compliance with boundaries. All goes well."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "The teacher faces a formal review for violating district policy prohibiting personal services from students."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Mr. Jordan, a high school science teacher, is traveling to a conference. He asks one of his students to water his plants and feed his pet while he is away. The student agrees.",
					"title": "Situation 2: Personal Favors",
					"number": 2,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 9,
				"sourceId": 3090
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103660,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Potential Ethical Outcomes",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Diana accepts the tickets. When the publisher’s materials are adopted, colleagues raise concerns about impartiality, damaging trust within the department."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Diana discloses the gift to administration. Her transparency results in corrective guidance and ethics training rather than formal discipline."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "Diana posts photos from the game on social media. The district discovers the gift. Diana faces disciplinary action for violating district policy on vendor gifts and conflicts of interest."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Diana is a department head responsible for selecting instructional materials. A textbook publisher offers her basketball tickets worth $500. Diana accepts the tickets.",
					"title": "Situation 7: Accepting Gifts",
					"number": 7,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 14,
				"sourceId": 3140
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103661,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Potential Ethical Outcomes",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Lydia immediately intervenes. She stops the gathering, confiscates the alcohol, contacts the students’ parents, and ensures everyone gets home safely. Although the situation is serious, her prompt action demonstrates responsibility and helps mitigate legal and professional consequences."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Lydia hesitates, concerned about overreacting after a long evening. The gathering continues, and later one student becomes ill. Parents become involved, and Lydia may face legal consequences for failing to act."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "Lydia ends the gathering. The incident is reported to the school. She undergoes a disciplinary review focused on professional judgment and maintaining a safe environment for minors, which may affect her employment or licensure."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Lydia is a high school teacher. After attending a school‑sponsored evening event, she arrives home late. While she was gone, Lydia’s teenage daughter invited four friends over to listen to music in her room. When Lydia enters the house, she finds the girls playing loud music, dancing, and drinking alcohol.",
					"title": "Situation 6: Social Host",
					"number": 6,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 13,
				"sourceId": 3130
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103662,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Potential Ethical Outcomes",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "The teacher apologizes to the student and offers modifications and alternative activities, repairing trust."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "The student becomes embarrassed and stops participating. The video of the teacher’s comment is posted on social media, goes viral, and sparks criticism about shaming."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "School administrators become aware of the video. The teacher faces disciplinary action for failing to maintain a supportive environment and violating professional standards."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "A physical education teacher organizes a fitness challenge in which students must complete a timed plank hold and a series of push-ups. One student struggles to meet the minimum requirement. Instead of offering support, the teacher says loudly, “If you can’t handle this, maybe you shouldn’t sign up for any sports.” Several students laugh, and one records the moment on their phone.",
					"title": "Situation 5: Fitness Challenge",
					"number": 5,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 12,
				"sourceId": 3120
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103663,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Potential Ethical Outcomes",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "The relationship escalates to an inappropriate level. Digital communications are audited, and the teacher faces termination and legal consequences."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "You consult district policy and respectfully encourage your colleague to seek guidance through professional ethics training."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "The relationship remains platonic, but rumors spread online. An investigation ensues, and the teacher resigns amid reputational damage."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "You notice a colleague meeting frequently with a student at coffee shops and exchanging personal messages with the student on social media platforms. The student appears emotionally attached, and the teacher seems to reciprocate.",
					"title": "Situation 4: Beyond Coffee",
					"number": 4,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 11,
				"sourceId": 3110
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103664,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Potential Ethical Outcomes",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Ms. Alvarez tutors the student virtually using her personal account. The student’s grades improve, but the arrangement violates district policy related to outside employment and student data privacy, placing Ms. Alvarez at professional risk."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Ms. Alvarez informs school administration about the tutoring offer. The district approves the arrangement under clear guidelines for compensation, supervision, and digital safety, protecting both the student and the teacher."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "Ms. Alvarez declines the paid tutoring offer and instead provides the family with district‑approved tutoring resources and a list of certified providers."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Ms. Alvarez is a sixth-grade math teacher. One of her students is struggling academically. The student’s parent offers to pay Ms. Alvarez to provide after‑school virtual tutoring. Ms. Alvarez considers using her personal videoconferencing account to conduct the sessions.",
					"title": "Situation 1: Tutoring",
					"number": 1,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 8,
				"sourceId": 3080
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103665,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will consider a scenario involving false reporting, student-to-student harassment, and remunerative conduct as they relate to interactions with students.\n\nFirst, you will review a video that shows an educator’s interactions with her student. Then, you will gain further insight by reviewing three videos showing the perspectives of people involved in the scenario. After observing the videos, you will reflect on and explore the ethical dilemmas depicted in the scenario.",
				"media": [
					{
						"type": "VIDEO",
						"title": "Crossed Lines",
						"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-3/m3s2_scenario.mp4",
						"transcript": "**Crossed Lines: Coach Buckner and Sarah**\n\nThe video shows two scenes. The video involves multiple students and Coach Buckner, and it begins in the hallway and ends in Coach Buckner’s office.\n\nScene 1: Sarah, Marti, and Maria are in the hallway. Marti and Maria are talking aggressively to Sarah.\n\nMarti: Hey Sarah, word’s out you’re flunking Coach’s geometry class. Guess Coach is going to replace you on the basketball team. It’s like you are trying to get kicked off a week before playoffs. Thanks a lot.\n\nMaria: Seriously, you know the whole team hates you by now.\n\nMarti: Maybe we should stuff some brains into her.\n\n[Coach Buckner calls down the hallway.]\n\nCoach Buckner: Sarah, come to my office.\n\nScene 2: Coach Buckner and Sarah are in Coach Buckner’s office. Coach Buckner is behind her desk, and Sarah is on the other side.\n\nSarah: I’m sorry, Coach. I didn’t say anything to the other girls, and I just didn’t want to react.\n\nCoach Buckner: We have more important things to discuss. These are this week’s academic reports, and they don’t match. [Coach Buckner removes some papers from a stack.] Playoffs are this week. And I have no problem making a player ineligible when they’re failing, especially when it’s my class. But I do have a problem making my top basketball player ineligible right now.\n\nSarah: I can bring my grade up. Please don’t cut me. I’ll do anything.\n\nCoach Buckner: Here are your options. Version one includes the fifty-five you earned on Monday. If I turn that in, you’re off the team today. Version two stays blank, but only if you come to study geometry with me at my house every weekend for two months and do yard work to make up for it.\n\nSarah: Okay, Coach. I’ll show up. I’ll improve. I don’t want to be cut. I’ll do anything.\n\nCoach Buckner: All right. Let’s call your dad and explain what’s going on.",
						"transcriptTitle": "Transcript for Crossed Lines video",
						"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
					}
				],
				"title": "Scenario 2: Coach Buckner",
				"instruction": "**Directions:** Review the following video to learn about the scenario. Select the play button to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_presentation",
				"language": "en-US",
				"position": 18,
				"sourceId": 3180
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103666,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Potential Ethical Outcomes",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Ms. Cho decides to follow testing protocols rather than informal advice. She provides only the approved accommodations and documents the student’s request for future review, ensuring fairness and compliance."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Ms. Cho interprets the colleague’s advice broadly and translates parts of the test. Other students notice and request similar help, creating equity concerns and disrupting the testing environment."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "The additional assistance is later identified during test review. Scores are invalidated, and Ms. Cho is subject to an ethics investigation for providing unauthorized support, with possible consequences for her employment and licensure."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "Ms. Cho is administering a standardized test. During the test, an English learner asks her to translate several test questions. Ms. Cho knows the student’s approved accommodations but is unsure whether translating the questions would go beyond what is allowed. She briefly asks a nearby teacher for guidance. The teacher responds, “Always help students.”",
					"title": "Situation 9: Test Security",
					"number": 9,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 16,
				"sourceId": 3160
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103667,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "**The Importance of Ethical Standards in Education**\n\nA state’s code of conduct and the *MCEE* function as binding agreements between the public and educational professionals entrusted with the responsibility of in loco parentis (that is, acting in place of the parent for students). These codes serve to ensure that, in return for the autonomy and privileges granted to educators, every member of the profession upholds their duties in a manner that withstands public examination and fosters trust within the community.\n\n**Consequences of Ethical Violations**\n\nUpon completing this scenario, it is important to consult your state’s code of conduct for educators. By doing so, you can determine what actions may be taken regarding an educator’s license if statutes related to student welfare, remunerative conduct, or falsification of records are violated. These matters are of critical importance and carry significant implications for professional standing and public trust.\n\n**Application of the** ***Model Code of Ethics for Educators*** (***MCEE***)\n\nThe *MCEE* is an essential resource, particularly if there is cause to suspect that a colleague may be nearing or is already involved in an ethically questionable situation. Within this code, Principles I, II, III, and IV outline standards that directly address expectations and responsibilities pertinent to scenarios involving student welfare, professional boundaries, and ethical decision making.",
				"title": "Module 3 Summary"
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "module_summary",
				"language": "en-US",
				"position": 24,
				"sourceId": 3240
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103668,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Review the ethical principles to determine whether each ethical principle was at immediate risk for Coach Buckner.",
				"items": [
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "When bullying occurs, educators should always refer students (that is, victims or offenders) to the appropriate resources and officials within the schooling structure and ensure appropriate follow-through as opposed to trying to solve the issues themselves."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "Promoting Solution Discovery"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "By not reporting bullying, by engaging in false reporting, and by proposing a quid pro quo solution, Coach Buckner is placing her professional status at high risk."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "Risk Mitigation"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Coach Buckner was not objective and neutral: she did not report the bullying, she proposed a solution that involves self-gain, and she was guilty of false reporting."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "Objectivity and Neutrality Are Maintained"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Coach Buckner should assess what occurred between the students, consider whether it reflects a broader pattern of harassment, and follow school procedures. Instead, Coach Buckner focuses on Sarah’s athletic eligibility and considers leaving Sarah’s earned grade off the academic report, which further compromises her responsibility to protect Sarah’s welfare."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "Ensuring Student Welfare"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Coach Buckner’s proposed handling of Sarah’s grade lacks transparency. One report includes the fifty-five Sarah earned, while the other leaves the grade blank; submitting or relying on the blank version would obscure Sarah’s actual academic status from the eligibility process."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "Transparency in Actions and Communications"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "When Coach Buckner tells Sarah she has to do yard work in exchange for private tutoring in geometry, Coach Buckner has transgressed boundaries."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "Honoring the Boundaries of Role, Time, and Place"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "An educator’s actions can cause doubt and distrust by undermining the effectiveness of a healthy educational structure. The professional educator has the obligation to hold themself responsible for ethical conduct."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "Integrity of the Profession Is Promoted by the Educator"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "Coach Buckner’s decision making is not guided by shared professional ethical standards. She considers omitting an earned grade from an eligibility report, does not appropriately address the bullying of Sarah, and proposes a private exchange of tutoring for yard work. These actions conflict with the *Model Code of Ethics for Educators*."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "Code of Ethics for Educators Is Maintained with Fidelity"
						}
					},
					{
						"back": {
							"selected": false,
							"riskLevel": "At Immediate Risk",
							"explanation": "False reporting, not reporting bullying, and engaging in remunerative conduct all transgress policy and public trust."
						},
						"front": {
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "Stewardship of the Law and Public Trust"
						}
					}
				],
				"title": "Scenario 2: Review",
				"instruction": "**Directions:** Select each of the following nine flip cards to explore whether each ethical principle was at immediate risk for Coach Buckner. Each of the nine cards has a front and back side with additional information.  Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_principle_review_cards",
				"language": "en-US",
				"position": 22,
				"sourceId": 3220
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103669,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The first step in navigating ethical dilemmas is to understand how your values and dispositions can affect your decisions. Educators’ decisions are influenced by two frameworks: dispositional and regulatory. The influence of each framework varies, and educators can be influenced more strongly by one framework than by another. Reflect on what influenced Coach Buckner’s decisions regarding her relationships with students.",
				"title": "Scenario 2: Reflect",
				"question": "Was Coach Buckner influenced more by her dispositional framework or the regulatory framework?",
				"instruction": "**Directions:** Select each of the following two frameworks to read its definition. Then answer the question by choosing one of the frameworks and selecting Submit. If needed, you can try again and select the alternative framework to reveal the explanation."
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "scenario_reflect_framework_choice",
				"language": "en-US",
				"position": 20,
				"sourceId": 3200
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "bc6430af-ea66-4ca6-b441-e8354b84f774",
						"isCorrect": true
					},
					{
						"choiceId": "53522a9a-5f4b-46b3-9da8-fa3a603cd021",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "bc6430af-ea66-4ca6-b441-e8354b84f774",
					"detailed": {
						"text": "This is a difficult choice! Clearly Coach Buckner has disregarded the regulatory framework by ignoring school and interscholastic athletic policies, as well as antibullying statutes. She is also not displaying dispositions valued by the education profession. However, Coach Buckner believes that she is making the right decision for the good of the team. In other words, she is operating within a dispositional framework guided only by her own values, not the profession’s values. When professional decision making becomes influenced by personal values, tools such as the *Model Code of Ethics for Educators* (*MCEE*) add clarity. Remember, your profession is stronger when ethical standards are based not on the subjectivity of individualism but rather on shared ethical principles."
					},
					"language": "en-US"
				},
				{
					"type": "STATIC",
					"choiceId": "53522a9a-5f4b-46b3-9da8-fa3a603cd021",
					"detailed": {
						"text": "Coach Buckner’s decisions in this scenario were not guided by the regulatory framework, which includes school and district policies, state eligibility rules, and laws governing educator conduct. Coach Buckner knowingly deviates from the requirements to submit accurate academic and eligibility reports and apply eligibility rules consistently."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "bc6430af-ea66-4ca6-b441-e8354b84f774",
						"icon": "heart-handshake",
						"text": "Influenced More by Dispositional Framework",
						"description": "The personal and professional attitudes, values, and beliefs that inform a professional educator’s decision making.",
						"numFirstSelections": 0
					},
					{
						"id": "53522a9a-5f4b-46b3-9da8-fa3a603cd021",
						"icon": "scale",
						"text": "Influenced More by Regulatory Framework",
						"description": "School or district policies, state statutes, and criminal laws that form the basis for conduct absolutes and inform a professional educator’s decision making.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103670,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "In this activity, you will be presented with a series of ten scenarios. After each situation, you will be presented with three flip cards that describe possible outcomes. Take a moment to think about what could possibly happen and consider the ethical implications of each choice.",
				"title": "Ethical Situations: Potential Ethical Outcomes",
				"situation": {
					"cards": [
						{
							"id": "A",
							"back": {
								"text": "Teachers collaborate to provide legitimate supports, such as after-school tutoring, family engagement, and enrichment activities, helping students improve without compromising integrity."
							},
							"label": "Outcome 1"
						},
						{
							"id": "B",
							"back": {
								"text": "Teachers push excessive test prep and narrow curriculum, increasing student stress. Parents complain about the negative impact on mental health and learning balance."
							},
							"label": "Outcome 2"
						},
						{
							"id": "C",
							"back": {
								"text": "Community concerns about incentive-driven education lead to school- and district-level discussions on ethical guidelines for external rewards."
							},
							"label": "Outcome 3"
						}
					],
					"count": 10,
					"setup": "A local company offers $10,000 to a school if their state test scores exceed the average. The principal urges teachers to “do whatever it takes.”",
					"title": "Situation 10: Test Scores",
					"number": 10,
					"prompt": "What could possibly happen?"
				},
				"instruction": "**Directions:** For each scenario, select each of the following three flip cards to learn about the possible outcomes for each situation. Each of the cards has a front and back side with additional information. Select the Flip button to review the reverse side of each card."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "ethical_situation",
				"language": "en-US",
				"position": 17,
				"sourceId": 3170
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103671,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Which of the following uses of electronic communication best reflects ethical and professional practice for Mr. Chang, a first-year teacher?"
				},
				"title": "Knowledge Check Question 1"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 25,
				"sourceId": 3250
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "d68ef396-c031-47aa-b64a-af29332ea377",
						"isCorrect": false
					},
					{
						"choiceId": "0309e4b1-d013-416d-8b07-0d13dd035b04",
						"isCorrect": true
					},
					{
						"choiceId": "2ec17e08-c68f-4c74-92d2-51aeac66261e",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "0309e4b1-d013-416d-8b07-0d13dd035b04",
					"detailed": {
						"text": "Using the school’s official social media account reflects ethical and professional use of electronic communication. It maintains clear boundaries and transparency while providing appropriate documentation. By using the school’s official social media account, Mr. Chang communicates through a channel that is sanctioned by the school, accessible to both students and parents, and subject to institutional oversight. This approach helps ensure professionalism, protects both the teacher and students, and supports accountability."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "d68ef396-c031-47aa-b64a-af29332ea377",
						"text": "Mr. Chang provides students with his personal username and invites them to message him directly for homework help.",
						"numFirstSelections": 0
					},
					{
						"id": "0309e4b1-d013-416d-8b07-0d13dd035b04",
						"text": "Mr. Chang uses the school’s official social media account to post homework assignments and class news for students and parents.",
						"numFirstSelections": 0
					},
					{
						"id": "2ec17e08-c68f-4c74-92d2-51aeac66261e",
						"text": "Mr. Chang sends emails from his school account to students’ personal email accounts to discuss their academic progress.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103672,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Examine a comprehensive analysis of Coach Buckner’s conduct in the scenario.",
				"items": [
					{
						"title": "False Reporting",
						"analysis": {
							"text": "In this scenario, Coach Buckner is contemplating falsifying an athletic eligibility report to ensure Sarah’s athletic participation. Manipulating grades, altering mandated reporting protocols, or submitting inaccurate academic records, even with good intentions, violates professional ethics and legal standards. Educators often face pressure from parents, colleagues, or administrators to compromise academic integrity for athletic success or group achievements. However, it is important to remember the following information.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are key considerations an educator should reflect on.\n- Falsification is never defensible. State interscholastic associations strictly enforce eligibility requirements. Violations can result in the following.\n- Sanctions against the athletic program\n- Employment termination\n- Licensure revocation\n- Legal action against the educator and school\n- Equal standards matter. If eligibility rules are not applied consistently, allegations of discrimination may arise, further jeopardizing the educator and institution.\n- Consider your professional responsibility. Educators must act as stewards of public trust by maintaining honesty and transparency in all reporting practices.",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Maintain honesty and transparency** in all reporting practices, even under pressure to compromise academic integrity for athletic or group achievements.",
							"title": "Key Takeaway"
						}
					},
					{
						"title": "Student-to-Student Harassment",
						"analysis": {
							"text": "The video reveals bullying and verbal harassment directed at Sarah by her peers. Educators have a legal and ethical obligation to intervene when a student’s safety, physical, emotional, or psychological, is compromised.\nSafety is paramount. It supersedes teaching effectiveness, test scores, and extracurricular priorities.",
							"title": "Analysis"
						},
						"questions": {
							"text": "Review the following resources for more information.\n- Antibullying laws: Virtually every state enforces statutes against harassment. Failure to act can result in the following.\n- Disciplinary action on the educator’s license\n- Civil liability for the school\n- Court precedents: Schools and staff are accountable for preventing both on-campus bullying and cyberbullying.",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Take appropriate action steps.** Document incidents, follow school policy, and ensure the learning environment remains a refuge of safety for all students.",
							"title": "Key Takeaway"
						}
					},
					{
						"title": "Remunerative Conduct",
						"analysis": {
							"text": "Coach Buckner’s offer, private tutoring in exchange for yard work, crosses professional boundaries and creates a conflict of interest.",
							"title": "Analysis"
						},
						"questions": {
							"text": "The following are key considerations an educator should reflect on.\n- Why is it unethical?\n- Using one’s position for personal gain violates Principle I of the *MCEE*.\n- Even with parental consent, such arrangements lack administrative approval and invite perceptions of impropriety.\n- Remember the risks of dual relationships.\n- Accepting gifts, favors, or services from students or families, even informally, can erode trust and fiduciary responsibility.\n- Innocent gestures may later be construed as grooming or misconduct in legal proceedings.\n- Consider professional boundaries. Maintain neutrality and avoid any appearance of favoritism or exploitation.",
							"title": "Questions"
						},
						"keyTakeaway": {
							"text": "**Avoid any exchange of personal services or gifts with students or families.** Even well-intentioned arrangements can create conflicts of interest and serious professional risk.",
							"title": "Key Takeaway"
						}
					}
				],
				"title": "Scenario 2: Analysis",
				"instruction": "**Directions:** Select each of the following three tabs to examine how false reporting, student-to-student harassment, and remunerative conduct relate to this scenario. Select each of the expandable text buttons within each tab to review the information about each topic."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_analysis_cards",
				"language": "en-US",
				"position": 23,
				"sourceId": 3230
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103673,
			"versionId": 1,
			"blockId": null,
			"type": "SATA",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "The second step in navigating ethical dilemmas is exploring the ethical principles.",
				"title": "Scenario 2: Explore",
				"question": "Which of the following ethical principles were at immediate risk for Coach Buckner? Select all that apply.",
				"instruction": "**Directions:** Select each of the following nine expandable text buttons to review information about each principle of ethical decision making.",
				"ethicalPrinciples": {
					"items": [
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-01-promoting-solution-discovery-illustration-v2.png"
								}
							],
							"title": "**P**romoting Solution Discovery",
							"description": "Creating opportunities for self-advocacy and problem resolution is a foundational principle in ethical decision making. Educators should refer students or colleagues to suitable school resources and officials and ensure that these students and colleagues follow up, rather than handle issues themselves. Not only is this in the best interest of those involved, but it also allows situations to be handled objectively and avoids blurring the scope of the educator’s position with that of more expansive roles such as those of counselor, confidant, caregiver, and rescuer. The primary role of the professional educator is most often associated with the tasks of teaching and learning.\n\n**Guiding Questions**\n- What are the inherent professional risks in attempting to fix the immediate or long-term challenges, problems, and obstacles that students, colleagues, or other learning community stakeholders encounter?\n- Am I accepting responsibilities, performing duties, or providing services that correspond with my training and area of certification?\n- How can I help colleagues when their role as a professional educator overlaps with other societal expectations?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-02-risk-mitigation-illustration-v2.png"
								}
							],
							"title": "**R**isk Mitigation",
							"description": "Since educators provide services directly to minors who remain under their care and supervision for extended periods of time without the presence of parents or guardians, the field of education has many professional risks and vulnerabilities. It is important that all educators continually reflect on how to best mitigate risks that may compromise their professional and personal credibility, career goals, personal well-being, and effectiveness as a teacher.\n\n**Guiding Questions**\n- How can a seemingly innocuous and insignificant decision have the potential to put my educational practice at risk?\n- What professional-risk situations inherent in my educational practice do I need to carefully consider (for example, chaperoning an overnight field trip, being approached by a student for personal advice)?\n- What conversations can I have with my colleagues to help identify ways to mitigate risks in situations that we commonly encounter?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-03-objectivity-neutrality-maintained-illustration-v3.png"
								}
							],
							"title": "**O**bjectivity and Neutrality Are Maintained",
							"description": "By maintaining objectivity and neutrality, professional educators should be able to evaluate a situation without emotional entanglements or bias. Remaining objective and neutral mitigates the risks of over-identifying with one party, becoming too focused on the needs of an individual, or advocating for a singular interest instead of advocating for solutions.\n\n**Guiding Questions**\n- When encountering competing tensions (for example, school policy versus what I think is best for a student or colleague; parental influence versus administrative influence), how can I determine the best course of action?\n- How can I remain objective and neutral when I have multiple relationships in the schooling community and as a community member (for example, I’m a friend of one of my student’s parents; I am a youth group leader at a student’s religious center; I coach a student on a club volleyball team during the summer)?\n- How can I best caution a colleague if I suspect the colleague is becoming overwhelmed by the needs of a student?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-04-ensuring-student-welfare-illustration-v2.png"
								}
							],
							"title": "**E**nsuring Student Welfare",
							"description": "Since the individuals receiving services are minors and the educators have been ascribed in loco parentis responsibilities, the primary responsibility of educators is to ensure the students’ safety and welfare. The scope of this charge is not just limited to physical safety, but it also includes emotional, intellectual, psychological, and sexual safety.\n\n**Guiding Questions**\n- Am I doing everything in my power to establish a safe and secure environment for academic, personal, and social growth to occur?\n- Am I willing to safeguard students from duress even if I am not directly responsible for the students?\n- How can I best confront a colleague regarding acts, either committed or omitted, that have the potential to compromise a student’s welfare?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-05-transparency-actions-communications-illustration-v2.png"
								}
							],
							"title": "**T**ransparency in Actions and Communications",
							"description": "Educators must be transparent in their actions and communications. Transparency establishes openness, accountability, trust, credibility, and boundaries. Failure to be sufficiently transparent with appropriate stakeholders (for example, parents, guardians, students, colleagues, administrators) may result in misinterpretation of motives or the appearance of impropriety. Transparency is the best way for educators to ensure that their decisions and behaviors can withstand public scrutiny.\n\n**Guiding Questions**\n- How can I ensure that all communications with students, including digital and electronic communications, are conducted with transparency?\n- How can I balance the need for transparency in my actions and communications with protecting highly confidential information that I am expected to retain (which is considered a “qualified privilege” by the courts)?\n- How do I best approach a colleague about rumors of impropriety that are a result of their lack of transparency in decision making?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-06-boundaries-role-time-place-illustration-v2.png"
								}
							],
							"title": "**H**onoring the Boundaries of Role, Time, and Place",
							"description": "Boundaries encompass the verbal, physical, emotional, and social distances that an educator must maintain to ensure security, structure, and predictability in an educational environment. Most often, the boundaries that are transgressed relate to role, time, and place. By respecting the functions and limits of contracted roles, as well as the working hours and location of the learning environment, secure boundaries are in place for all members of the school community.\n\n**Guiding Questions**\n- In reflecting on my educational practice, which dispositions most risk eroding professional boundaries (for example, assisting with students’ personal challenges, extending academic support beyond school hours, engaging in extracurricular activities, communication with students, parents, and colleagues)?\n- Am I thinking about all my interactions with students (for example, in the school, in the community, and at social functions) as an extension of my professional responsibilities as an educator?\n- How can my colleagues and I openly discuss and agree on boundaries that are most appropriate for our educational context?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-07-integrity-profession-illustration-v2.png"
								}
							],
							"title": "**I**ntegrity of the Profession Is Promoted by the Educator",
							"description": "Educators’ actions reflect on the schooling community, the district, and the profession. An individual educator’s positive actions have the potential to inspire public confidence in the profession. On the other hand, negative actions can cast shadows of doubt and distrust by undermining the effectiveness of a healthy educational structure. The professional educator has an obligation to hold himself or herself responsible for ethical conduct. The educator should take steps when he or she has reason to believe that another educator may be approaching or engaged in an ethically compromising situation.\n\n**Guiding Questions**\n- How often am I reflecting on the daily decisions that I make as a professional educator and how those decisions may affect the integrity of the profession?\n- What steps can I take when I believe that a colleague may be approaching or involved in an ethically compromising situation?\n- How can I best advocate for the profession while also working to reconcile points of disagreement within the school or district?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-08-code-ethics-fidelity-illustration-v2.png"
								}
							],
							"title": "**C**ode of Ethics for Educators Is Maintained with Fidelity",
							"description": "Having an ethics code is a proclamation that a profession is better off when ethical standards are not based solely on individual assessments of what is or is not ethically acceptable but reflect consensus among members on a common purpose. For the education discipline, the *Model Code of Ethics for Educators* (*MCEE*) is a guide for what educators should expect of themselves and one another and should be maintained with fidelity. The *MCEE* assists educators in their efforts to resolve ethical dilemmas and helps educators defend their decisions to schooling-community constituents, institutions, courts, and any other agency that would encourage them to go against the values of the profession. The formal standards are not a substitute for an active, deliberate, and creative approach to fulfilling your ethical responsibilities. They prompt, guide, and inform an educator’s ethical decision-making; they do not serve as a substitute for it.\n\n**Guiding Questions**\n- How can educators from my school or district work together to identify common ethical dilemmas that we encounter?\n- Is there a way to use the *MCEE* as a prompt to discuss resolutions to those ethical dilemmas?\n- Since ethical dilemmas are often situational, contextual, and likely to change over time, how can the *MCEE* continue to guide and inform my decision making as I engage in the practical realities of my work?"
						},
						{
							"media": [
								{
									"type": "IMAGE",
									"imageUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/principles/principle-09-stewardship-law-public-trust-illustration-v2.png"
								}
							],
							"title": "**S**tewardship of the Law and Public Trust",
							"description": "Employment policies, licensure statutes, and community laws represent conduct absolutes that have originated from a history of judicial activity. They represent the lowest standard of acceptable behavior deemed necessary to safeguard community members. However, the professional educator is aware that trust in the profession depends on a level of conduct and responsibility that may be higher than what is required by law.\n\n**Guiding Questions**\n- How will relevant procedures, policies, and laws inform my decision making when I encounter ethical dilemmas?\n- It has been said that misconduct is not an event but a process. Will I be able to identify those situations where a series of gradual and unintentional missteps could lead to the transgression of a conduct absolute?\n- What steps can I take when I believe that a colleague may be approaching or involved in actions that may lead to the transgression of a policy, statute, or law?"
						}
					],
					"title": "Ethical Principles"
				}
			},
			"metadata": {
				"type": "SATA",
				"ui_type": "scenario_principle_sata_activity",
				"language": "en-US",
				"position": 21,
				"sourceId": 3210
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "8e3595e4-777d-43a9-8e89-c248a9dbc272",
						"isCorrect": true
					},
					{
						"choiceId": "57c07fed-4751-4b45-8caa-e353aa8a968e",
						"isCorrect": true
					},
					{
						"choiceId": "d99d6a6d-9d44-404f-9ec1-785a76149080",
						"isCorrect": true
					},
					{
						"choiceId": "c13e0d2a-7a74-4293-8bab-7cf0838a920d",
						"isCorrect": true
					},
					{
						"choiceId": "5ccf76f7-aaef-40c8-a723-38844b5754cf",
						"isCorrect": true
					},
					{
						"choiceId": "6f88894d-985d-4c3e-a079-44671b3c039d",
						"isCorrect": true
					},
					{
						"choiceId": "542741db-fb4f-4715-b3b6-81eac1541325",
						"isCorrect": true
					},
					{
						"choiceId": "7df8b03d-b4fe-4f63-a1f5-edb37a9b9558",
						"isCorrect": true
					},
					{
						"choiceId": "e1c877e0-b8ac-41d3-b190-5a04ab560d1d",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 9,
					"min": 1
				}
			},
			"feedback": null,
			"response": {
				"type": "MULTIPLE_SELECT",
				"choices": [
					{
						"id": "8e3595e4-777d-43a9-8e89-c248a9dbc272",
						"text": "Promoting Solution Discovery",
						"numFirstSelections": 0
					},
					{
						"id": "57c07fed-4751-4b45-8caa-e353aa8a968e",
						"text": "Risk Mitigation",
						"numFirstSelections": 0
					},
					{
						"id": "d99d6a6d-9d44-404f-9ec1-785a76149080",
						"text": "Objectivity and Neutrality Are Maintained",
						"numFirstSelections": 0
					},
					{
						"id": "c13e0d2a-7a74-4293-8bab-7cf0838a920d",
						"text": "Ensuring Student Welfare",
						"numFirstSelections": 0
					},
					{
						"id": "5ccf76f7-aaef-40c8-a723-38844b5754cf",
						"text": "Transparency in Actions and Communications",
						"numFirstSelections": 0
					},
					{
						"id": "6f88894d-985d-4c3e-a079-44671b3c039d",
						"text": "Honoring the Boundaries of Role, Time, and Place",
						"numFirstSelections": 0
					},
					{
						"id": "542741db-fb4f-4715-b3b6-81eac1541325",
						"text": "Integrity of the Profession Is Promoted by the Educator",
						"numFirstSelections": 0
					},
					{
						"id": "7df8b03d-b4fe-4f63-a1f5-edb37a9b9558",
						"text": "Code of Ethics for Educators Is Maintained with Fidelity",
						"numFirstSelections": 0
					},
					{
						"id": "e1c877e0-b8ac-41d3-b190-5a04ab560d1d",
						"text": "Stewardship of the Law and Public Trust",
						"numFirstSelections": 0
					}
				],
				"shuffle": false
			},
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103674,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Mr. Norton is a physical education instructor and coach. Concerns have been raised about whether his conduct toward students during practices and games may place their safety or well‑being at risk.\n\nWhich of the following statements by players on Mr. Norton’s team would offer the clearest indication that his conduct may have crossed professional boundaries related to student safety?"
				},
				"title": "Knowledge Check Question 5"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 29,
				"sourceId": 3290
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "d58dfe43-f851-4db3-b6df-edfac897a573",
						"isCorrect": false
					},
					{
						"choiceId": "105c969f-0a96-44fe-88e9-5c492518cb1b",
						"isCorrect": true
					},
					{
						"choiceId": "1c82f411-ba00-46ce-ac28-0b559363c4c0",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "105c969f-0a96-44fe-88e9-5c492518cb1b",
					"detailed": {
						"text": "The other two options are comments about how Mr. Norton conducts his workouts. There may be legitimate reasons for Mr. Norton's actions in those scenarios, but there can be no legitimate reason for a coach to throw a baseball bat at a student."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "d58dfe43-f851-4db3-b6df-edfac897a573",
						"text": "Mr. Norton made us run laps around the track until we all felt exhausted.",
						"numFirstSelections": 0
					},
					{
						"id": "105c969f-0a96-44fe-88e9-5c492518cb1b",
						"text": "Mr. Norton threw a baseball bat at a player who talked back to him.",
						"numFirstSelections": 0
					},
					{
						"id": "1c82f411-ba00-46ce-ac28-0b559363c4c0",
						"text": "Mr. Norton just says, “Tough it out!” when we complain about workouts.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103675,
			"versionId": 1,
			"blockId": null,
			"type": "LEARNING_MODULE",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"text": "Gain further insight by reviewing the following three videos showing the perspectives of the assistant coach, the athletic director, and Mr. Arnold (a colleague).",
				"items": [
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-3/m3s2_perspective_assistant_coach.mp4",
							"transcript": "**Assistant Coach’s Reflection**\n\nThe video shows the assistant coach talking to Coach Buckner in the gymnasium’s equipment room. The assistant coach is holding a clipboard.\n\nAssistant Coach: Look, we both know technically this could get us in trouble, but hey, it’s not a flagrant foul, right?\n\n[Coach Buckner nods in agreement.]\n\nYou didn’t write a false grade. You just left it off for a week.\n\nBesides, it’s what’s best for the team, especially after you let the girls work out their issues with Sarah without us stepping in.",
							"transcriptTitle": "Transcript for Assistant Coach video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Assistant Coach"
					},
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-3/m3s2_perspective_warning.mp4",
							"transcript": "**Athletic Director’s Warning**\n\nThe video shows the athletic director meeting with Coach Buckner, the assistant coach, and two other coaches in the staff conference room. They are all sitting around a conference table, and the athletic director has an open laptop. The coaches all nod in agreement as the athletic director talks to them.\n\nAthletic Director: Coaches, listen up. The Athletic Association has issued a zero tolerance policy for late or misleading academic reports.\n\nKnowingly misrepresenting information or failing to file on time will result in team suspension and disciplinary action for coaches.\n\nLet’s not lose games or credibility because of paperwork. Do what’s right for our student athletes.",
							"transcriptTitle": "Transcript for Athletic Director video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Athletic Director"
					},
					{
						"media": {
							"type": "VIDEO",
							"videoUrl": "https://services.memorang.com/storage/v1/object/public/memorang-assets/partners/proethica/final/module-3/m3s2_perspective_community_eyes.mp4",
							"transcript": "**Community Eyes**\n\nThe video shows Mr. Arnold talking to Coach Buckner in the front yard of Coach Buckner’s house. Coach Buckner is holding a rake.\n\nMr. Arnold: Hi there. I drove by last weekend and saw Sarah doing yard work. It looks like she is starting a gardening business.\n\nI may ask her to take on some work at my place.\n\nI wonder if you need to ask the school for permission before hiring students?",
							"transcriptTitle": "Transcript for Mr. Arnold (Colleague) video",
							"transcriptInstruction": "**Directions:** Select the following expandable text button to access the transcript of the video."
						},
						"title": "Mr. Arnold (Colleague)"
					}
				],
				"title": "Scenario 2: Perspectives",
				"instruction": "**Directions:** Select each of the following three tabs to review the three perspective videos. Select the play button in each tab to begin. Use the video controls when needed."
			},
			"metadata": {
				"type": "LEARNING_MODULE",
				"ui_type": "scenario_perspective_resource_set",
				"language": "en-US",
				"position": 19,
				"sourceId": 3190
			},
			"scoring": null,
			"feedback": null,
			"response": null,
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103676,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "In which of the following situations is a teacher most clearly obligated to report the incident to a supervisor or the authorities?"
				},
				"title": "Knowledge Check Question 4"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 28,
				"sourceId": 3280
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "a2980abe-0f6e-4902-b45d-ae4bd6794749",
						"isCorrect": true
					},
					{
						"choiceId": "c2b6a004-64c5-46c3-a2db-f8979f815e94",
						"isCorrect": false
					},
					{
						"choiceId": "089f0173-075a-47cc-a35e-a1e7ab554c79",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "a2980abe-0f6e-4902-b45d-ae4bd6794749",
					"detailed": {
						"text": "Professional educators are under a clear and direct duty to ensure student safety and welfare by reporting possible drug use by students, especially when it occurs on school grounds."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "a2980abe-0f6e-4902-b45d-ae4bd6794749",
						"text": "A teacher detects evidence that a student in the school parking lot may be under the influence of an illegal substance at the end of the school day.",
						"numFirstSelections": 0
					},
					{
						"id": "c2b6a004-64c5-46c3-a2db-f8979f815e94",
						"text": "A teacher overhears two female students in the hallway discussing one girl’s interest in dating an older male student.",
						"numFirstSelections": 0
					},
					{
						"id": "089f0173-075a-47cc-a35e-a1e7ab554c79",
						"text": "A teacher notices that a usually outstanding student misunderstood the directions for a writing assignment and received a poor grade.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103677,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Mr. Carrington, a social studies teacher, has three students in his class who have been bullied by another student in the same class. Mr. Carrington has taken all the necessary steps in response to the bullying. He feels, however, that the three students’ grades have suffered because of the negative incidents in the classroom. In response, Mr. Carrington decides to raise the final course grades for the bullied students by half a letter grade.\n\nMr. Carrington’s decision to adjust the grades of the bullied students and not those of other students most clearly puts which of the following principles at risk?"
				},
				"title": "Knowledge Check Question 3"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 27,
				"sourceId": 3270
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "934f090c-39eb-44e5-9921-98b2fd317712",
						"isCorrect": false
					},
					{
						"choiceId": "002589dd-497d-4ce6-9263-ec50a1c26a91",
						"isCorrect": false
					},
					{
						"choiceId": "c8cfa10e-2432-4f87-b417-57b5556bca6d",
						"isCorrect": true
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "c8cfa10e-2432-4f87-b417-57b5556bca6d",
					"detailed": {
						"text": "This situation puts the level of honesty in Mr. Carrington’s grading policy at risk. Although Mr. Carrington’s concern for the students who were bullied is understandable, raising their grades would be unfair to the other students in his class."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "934f090c-39eb-44e5-9921-98b2fd317712",
						"text": "Being proactive about ethical concerns that affect students",
						"numFirstSelections": 0
					},
					{
						"id": "002589dd-497d-4ce6-9263-ec50a1c26a91",
						"text": "Avoiding multiple relationships with students that can influence the teacher’s effectiveness",
						"numFirstSelections": 0
					},
					{
						"id": "c8cfa10e-2432-4f87-b417-57b5556bca6d",
						"text": "Demonstrating a commitment to equality and equity among students",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		},
		{
			"id": 103678,
			"versionId": 1,
			"blockId": null,
			"type": "MCQ",
			"parentId": null,
			"recordType": "ITEM",
			"content": {
				"stem": {
					"text": "Ms. Connor’s husband owns and operates a fitness company. Ms. Connor, as a high school teacher, mentions her husband’s business to her students who play on the football team and offers them a special discount on training sessions.\n\nWhich of the following is true of Ms. Connor’s behavior?"
				},
				"title": "Knowledge Check Question 2"
			},
			"metadata": {
				"type": "MCQ",
				"ui_type": "knowledge_check_question",
				"language": "en-US",
				"position": 26,
				"sourceId": 3260
			},
			"scoring": {
				"type": "EXACT_MATCH",
				"answerKey": [
					{
						"choiceId": "cb4e58ea-ae2b-4d3b-9e3f-04a885bf8ec9",
						"isCorrect": false
					},
					{
						"choiceId": "efe7002c-8719-4201-bbf0-ea9732ba7c3a",
						"isCorrect": true
					},
					{
						"choiceId": "2fd80883-2258-41fb-a549-6dd5a9a05665",
						"isCorrect": false
					}
				],
				"selection": {
					"max": 1,
					"min": 1
				}
			},
			"feedback": [
				{
					"type": "STATIC",
					"choiceId": "efe7002c-8719-4201-bbf0-ea9732ba7c3a",
					"detailed": {
						"text": "It is ethically risky for an educator to encourage students to purchase services from the educator or the educator's spouse, because the educator will benefit financially in either case. Ms. Connor is creating a conflict between her interests and duties as an objective educator and her role as the wife of a business owner."
					},
					"language": "en-US"
				}
			],
			"response": {
				"type": "SINGLE_CHOICE",
				"choices": [
					{
						"id": "cb4e58ea-ae2b-4d3b-9e3f-04a885bf8ec9",
						"text": "It is appropriate as long as she informs the school’s football coach of her offer.",
						"numFirstSelections": 0
					},
					{
						"id": "efe7002c-8719-4201-bbf0-ea9732ba7c3a",
						"text": "It is inappropriate because her husband will benefit financially if her students sign up for the sessions.",
						"numFirstSelections": 0
					},
					{
						"id": "2fd80883-2258-41fb-a549-6dd5a9a05665",
						"text": "It is inappropriate because she should not offer discounts to only her students.",
						"numFirstSelections": 0
					}
				],
				"shuffle": false,
				"instruction": "Choose the best answer from the following options."
			},
			"tags": [
				{
					"id": 37089,
					"label": "Module 3: The Professional Educator and the Student",
					"title": "Module 3: The Professional Educator and the Student",
					"type": "Learning Module",
					"code": null,
					"displayType": ["Display", "Filter", "Progress"]
				}
			],
			"score": null
		}
	],
	"examName": "Module 3: The Professional Educator and the Student",
	"sessionSubType": "PRACTICE_TEST",
	"publicId": "d6cf6223-a656-4ca5-9355-eab6900551d1",
	"sessionType": "SUMMATIVE",
	"totalTime": null
}
